var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheduleIcon = function SvgScheduleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "calendar")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(6.000000, 6.000000)",
    fill: "#0086D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9148694,21.1552139 L2.29364109,21.1552139 L2.29364109,7.48858722 L21.9148694,7.48858722 L21.9148694,21.1552139 Z M20.8956266,1.74784743 C20.8956266,0.713370349 20.0395914,2.68229883e-13 18.9849487,2.68229883e-13 L18.9849487,1.74784743 L17.0728915,1.74784743 L7.19906311,1.74784743 C7.19906311,0.713370349 6.34302789,2.68229883e-13 5.28700592,2.68229883e-13 L5.28700592,1.74784743 L3.37632796,1.74784743 L2.54833686,1.74784743 C1.14061406,1.74784743 2.71782596e-13,2.8647404 2.71782596e-13,4.24419329 L2.71782596e-13,20.8440151 C2.71782596e-13,22.2225672 1.14061406,23.3399106 2.54833686,23.3399106 L21.27813,23.3399106 C22.6853931,23.3399106 23.8255474,22.2225672 23.8255474,20.8440151 L23.8255474,4.24419329 C23.8255474,2.8647404 22.6853931,1.74784743 21.27813,1.74784743 L20.8956266,1.74784743 Z",
    id: "Page-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.125,
    cy: 1.875,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.625,
    cy: 1.875,
    r: 1.875
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule_icon.17a98b09.svg";
export { ForwardRef as ReactComponent };